export const CONTRACTS_BY_TYPE_COLUMNS = [
  {
    Header: "Type",
    accessor: "contract_type",
    id: "contract_type",
    minWidth: 130
  },
  {
    Header: "Contact Name",
    id: "name",
    accessor: "name",
    minWidth: 220
  },
  {
    Header: "Rate",
    accessor: "billing_rate",
    id: "billing_rate",
    Cell: ({ value }) => (value ? `$${value}` : "--"),
    minWidth: 80
  },
  {
    Header: "Frequency",
    accessor: "invoice_frequency",
    id: "invoice_frequency",
    Cell: ({ value }) => value || "--",
    minWidth: 120
  },
  {
    Header: "Day To Send",
    accessor: "day_to_send_invoice",
    id: "day_to_send_invoice",
    Cell: ({ value }) => value || "--",
    minWidth: 100
  },
  {
    Header: "Format",
    accessor: "invoice_format",
    id: "invoice_format",
    Cell: ({ value }) => value || "--",
    minWidth: 80
  },
  {
    Header: "Email",
    accessor: "invoice_email",
    id: "invoice_email",
    Cell: ({ value }) => value || "--",
    minWidth: 180
  },
  {
    Header: "Report",
    accessor: "report",
    id: "report",
    Cell: ({ value }) => value || "--",
    minWidth: 120
  },
  {
    Header: "Report Frequency",
    accessor: "report_frequency",
    id: "report_frequency",
    Cell: ({ value }) => value || "--",
    minWidth: 130
  },
  {
    Header: "Day to Send",
    accessor: "day_to_send_report",
    id: "day_to_send_report",
    Cell: ({ value }) => value || "--",
    minWidth: 100
  },
  {
    Header: "Format",
    accessor: "report_format",
    id: "report_format",
    Cell: ({ value }) => value || "--",
    minWidth: 80
  },
  {
    Header: "Email",
    accessor: "report_email",
    id: "report_email",
    Cell: ({ value }) => value || "--",
    minWidth: 180
  }
];
